export enum PacklinkAuthAction {
  Login = 'LOGIN',
  Register = 'REGISTER',
}
